/**
 * Central activation readiness thresholds (v1).
 * Components must not invent local copies — change only here + matching tests.
 */
export const ACTIVATION_READINESS_THRESHOLDS = {
  /** Recent heartbeat window for "agent connected / online enough for review". */
  recentHeartbeatMaxAgeMs: 5 * 60 * 1000,

  earlyReview: {
    minEventSpanMinutes: 120,
    minTrackedActivityMinutes: 30,
    minAppLogSessions: 5,
    /** Waived when periodicScreenshotsEnabled === false. */
    minScreenshotsWhenEnabled: 3,
  },

  dailyInsights: {
    /** Actual first-to-last event span, not wall-clock since install. */
    minEventSpanMinutes: 240,
  },

  /**
   * Founder private-test "own workday" — evidence-based, not four wall-clock hours alone.
   * Slightly lighter than employee early-review (self-proof, not Keep/Scale gate).
   */
  founderDay: {
    minEventSpanMinutes: 120,
    minTrackedActivityMinutes: 20,
    minAppLogSessions: 3,
    minScreenshotsWhenEnabled: 2,
  },
} as const;

export type ActivationReadinessThresholds = typeof ACTIVATION_READINESS_THRESHOLDS;
